export function EnumProp(e, d) {
    return {
        default: d,
        validator(v) {
            return e[v] !== undefined;
        }
    };
}
